import React, { useEffect, useRef } from 'react'
import t from 'prop-types'
import { css } from 'linaria'
import cx from 'classnames'

import PillarChapterHeader from '../PillarChapterHeader'
import PillarContentHeader from '../PillarContentHeader'
import PillarRelatedReading from '../PillarRelatedReading'
import PillarContributors from '../PillarContributors'
import PillarCTA from '../PillarCTA'
import Image from '../../Images/Image'
import WYSIWYG from '../../WYSIWYG'

const wysiwygCSS = css`
  & > div {
    p,
    ul,
    ol {
      @apply mt-5 mb-6 !important;
      @screen md {
        @apply mb-8 !important;
      }
    }

    li {
      @apply mt-5 !important;
      @screen md {
        @apply mt-5 !important;
      }
    }
  }
`

// figcaption CSS overrides
const figcaptionCSS = css`
  @apply py-5 my-0;

  & > .pillar-content__wysiwyg > div {

    &,
    & > * {
      @apply text-base text-gray-500;
    }
  }
`

const PillarChapterWrapper = ({ groupedContent, index, setChapterRef }) => {
  const chapterRef = useRef()
  useEffect(() => {
    setChapterRef(chapterRef)
  }, [setChapterRef, chapterRef])

  return (
    <div
      id={`chapter-${index}`}
      className="pillar-chapter-wrapper inline-block w-full"
      ref={chapterRef}
      data-index={index}
    >
      {groupedContent.map(item => {
        switch (item.fieldGroupName) {
          case 'post_Acfpillarpage_Content_Chapter':
            return <PillarChapterHeader data={item}></PillarChapterHeader>

          case 'post_Acfpillarpage_Content_Heading':
            return <PillarContentHeader data={item}></PillarContentHeader>

          case 'post_Acfpillarpage_Content_Image':
            return (
              <figure className="max-w-screen-md mx-auto my-6 lg:my-8 md:px-5 lg:px-0">
                <Image
                  alt={item.image.altText}
                  src={item.image.mediaItemUrl}
                  srcSet={item.image.srcSet}
                  className="w-full h-auto"
                  width={item.image.mediaDetails.width}
                  height={item.image.mediaDetails.height}
                />
                {item.includeCaption && item.caption && (
                  <figcaption
                    className={cx(
                      `${figcaptionCSS} px-5 lg:px-0 max-w-screen-md mx-auto`
                    )}
                  >
                    <div
                      className={cx(
                        `${wysiwygCSS} pillar-content__wysiwyg text-sm`
                      )}
                    >
                      <WYSIWYG content={item.caption}></WYSIWYG>
                    </div>
                  </figcaption>
                )}
              </figure>
            )

          case 'post_Acfpillarpage_Content_Related':
            return <PillarRelatedReading data={item}></PillarRelatedReading>

          case 'post_Acfpillarpage_Content_Cta':
            return <PillarCTA data={item}></PillarCTA>

          case 'post_Acfpillarpage_Content_Contributors':
            return <PillarContributors data={item}></PillarContributors>

          case 'post_Acfpillarpage_Content_Wysiwyg':
            return (
              <div
                className={cx(
                  `${wysiwygCSS} pillar-content__wysiwyg px-5 lg:px-0 max-w-screen-md mx-auto`
                )}
              >
                <WYSIWYG content={item.content}></WYSIWYG>
              </div>
            )

          default:
            break
        }

        return ''
      })}
    </div>
  )
}

PillarChapterWrapper.propTypes = {
  groupedContent: t.array,
  setChapterRef: t.func,
}

PillarChapterWrapper.defaultProps = {
  groupedContent: [],
  setChapterRef: () => {},
}

export default PillarChapterWrapper
